/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

const NAVIGATE_START = Symbol('ui/NAVIGATE_START');
const NAVIGATE_STOP = Symbol('ui/NAVIGATE_STOP');

type NavigateStartAction = Action<typeof NAVIGATE_START, null>;
type NavigateStopAction = Action<typeof NAVIGATE_STOP, null>;

export type NavigatingState = boolean;

const initialState: NavigatingState = false;

export default createReducer(initialState, {
  [NAVIGATE_START]() {
    return true;
  },

  [NAVIGATE_STOP]() {
    return false;
  },
});

export const navigateStart = actionCreator<NavigateStartAction>(NAVIGATE_START);
export const navigateStop = actionCreator<NavigateStopAction>(NAVIGATE_STOP);



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/navigating.ts